import React, { useEffect, useState, useRef } from 'react';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import {
    MDBContainer,
    MDBCol,
    MDBRow,
    MDBBtn,
    MDBInput,
    MDBCard,
    MDBCardBody,
    MDBCardHeader,
    MDBInputGroup,
    MDBDatepicker,
    MDBSelect,
    MDBDatatable,
    MDBIcon,
    MDBPopconfirm, MDBPopconfirmMessage,
    MDBModal, MDBModalDialog, MDBModalContent, MDBModalHeader, MDBModalTitle, MDBModalBody, MDBModalFooter,

} from 'mdb-react-ui-kit';
import Helper from '../Helper';
import Navbar from './sub/navbar';
import JobDetail from './sub/JobDetail';
import moment from 'moment';
import Alert from './sub/dialog'

const Component = () => {
    const { state } = useLocation();
    const error = useRef();
    const setError = (message) => error.current.showerror(message);
    const addjob = useRef();
    const editjob = useRef();
    const [customers, SetCustomers] = useState([]);
    const [transportJobList, setTransportJobList] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [basicModal, setBasicModal] = useState(false);
    const toggleOpen = () => setBasicModal(!basicModal);
    const [transport, setTransport] = useState({});
    const [selectedrow, setSelectedRow] = useState(null);


    const [resultData, setResultData] = useState({
        columns: [
            { label: "วันที่", field: 'jobdate', sort: false },
            { label: "ผู้ว่าจ้าง", field: 'customername', sort: false },
            { label: "งาน", field: 'jobname', sort: false },
            { label: "ปลายทาง", field: 'destination', sort: false },
            { label: "ขนาด", field: 'boxsize', sort: false },
            { label: "เบอร์ตู้", field: 'boxno', sort: false },
            { label: "จ่าย", field: 'paidby', sort: false },
            { label: "คนรถ", field: 'driver', sort: false },
            { label: "ทะเบียน", field: 'lcplate', sort: false },
            { label: "แก้ไข", field: 'action', sort: false }

        ],
        rows: []
    });


    useEffect(() => {

        generateTree(transportJobList);

    }, [transportJobList]);
    const saveData = async (e) => {
        e.preventDefault();
        if (transportJobList.length == 0) setError("ไม่มีข้อมูลการขนส่ง");
        setIsLoading(true);
        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/api/saveTransport`, {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${Helper.gettoken()}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ transport, transportJobList }),
            });
            const data = await response.json();
            if (response.ok) {
                setTransport(data.transport);
                setTransportJobList([...data.transportJobList]);
                error.current.showmessage("บันทึกข้อมูลเรียบร้อยแล้ว")
            } else {

                setError(data.message);
            }
        } catch (err) {
            setError('An error occurred. Please try again later.');
        }
        finally {
            // Reset loading state
            setIsLoading(false);
        }

    }
    const navigate = useNavigate();




    useEffect(() => {
        // Get the token from sessionStorage


        if (!["user", "admin"].includes(Helper.getuserrole())) {
            navigate('/main');
            return;
        }
        Helper.getCustomers(SetCustomers, setError);

    }, []);

    const addTransportJob = (e) => {
        var transportJob = addjob.current.getResult();
        if (transportJob.customerid == 0) {
            setError('ไม่ได้เลือกผู้ว่าจ้าง');
            return;
        }
        if (transportJob.jobname == "") {
            setError('ไม่ได้เลือกงาน');
            return;
        }
        var item = transportJobList || [];
        item.push(transportJob);
        setTransportJobList([...item]);

    }
    const addNewAddress = async (address, e) => {
        e.preventDefault();
        if (!address) return;
        const addressValue = addjob.current.getAddress(address);
        if (!addressValue) {
            setError('ไม่ได้ใส่ข้อมูลลูกค้า');
            return;
        };
        setIsLoading(true);
        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/api/saveitemaddress/${address}`, {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${Helper.gettoken()}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ item: { text: addressValue } }),
            });

            if (response.ok) {
                const data = await response.json();
                addjob.current.updateList();
                error.current.showmessage("บันทึกข้อมูลลูกค้าเรียบร้อยแล้ว");
            } else {
                const message =await response.text();
                setError(message);
            }
        } catch (err) {
            setError('An error occurred. Please try again later.');
        }
        finally {
            // Reset loading state
            setIsLoading(false);
        }


    };
    const endEdit = () => {

        setBasicModal(false);
        var editeddata = editjob.current.getResult()
        selectedrow.row = Object.assign(selectedrow.row, editeddata);
        var item = transportJobList;

        setTransportJobList([...item]);


    }
    const editRow = (row) => {

        setBasicModal(true);
        setSelectedRow({ row });

    }
    const deleteRow = (row) => {

        var item = transportJobList.filter(el => el !== row);;

        setTransportJobList([...item]);

    }

    const generateTree = (item) => {
        var main = item.map((row) => {
            return {
                ...row,
                action: (
                    <>
                        <MDBBtn outline size='sm' floating className='call-btn' onClick={() => editRow(row)}>
                            <MDBIcon icon='pen' />
                        </MDBBtn>
                        <MDBPopconfirm

                            onConfirm={() => deleteRow(row)}
                            placement='bottom'
                            btnChildren={<MDBIcon icon='trash' />}
                            btnClassName='ms-2 btn-sm btn-danger btn-floating'
                            cancelBtnText='ยกเลิก'
                            confirmBtnText='ตกลง'
                            confirmBtnClasses='btn-danger'
                            cancelBtnClasses='btn btn-outline-primary'
                        >
                            <MDBPopconfirmMessage>ยืนยันที่จะลบ?</MDBPopconfirmMessage>
                        </MDBPopconfirm>

                    </>
                )

            }
        });



        var _resultData = {

            rows: main
        }

        _resultData.columns = [...resultData.columns];

        setResultData(_resultData);


    }

    return (<>
        <Navbar />
        <MDBContainer fluid className="my-3">
            <Alert ref={error} />

            <MDBRow className="justify-content-center">
                <MDBCol md="12">
                    <MDBCard className="shadow-4 rounded-5">
                        <MDBCardHeader>
                            <MDBRow className='bg-body-tertiary d-flex align-items-center'>
                                <MDBCol md='9'>
                                    <h4>ลงข้อมูลงานขนส่ง</h4>
                                </MDBCol>
                                <MDBCol md='1' offsetMd='1'>
                                    <div className="d-grid gap-2 d-md-flex justify-content-md-end">
                                        {transport.name && <MDBBtn rounded size='lg' color='info' disabled={isLoading} onClick={() => window.open('/Print/Transport/' + transport.name, '_blank')}>พิมพ์</MDBBtn>}

                                    </div>
                                </MDBCol>

                                <MDBCol md='1'>
                                    <div className="d-grid gap-2 d-md-flex justify-content-md-end">
                                        <MDBBtn rounded size='lg' color='secondary' onClick={saveData} disabled={isLoading}>บันทึก</MDBBtn>
                                    </div>
                                </MDBCol>
                            </MDBRow>


                        </MDBCardHeader>
                        <MDBCardBody>

                            {customers.length > 0 && <JobDetail addNewAddress={addNewAddress} setError={setError} customers={customers} ref={addjob} disabledCustomer={transportJobList.length > 0} />}
                            <MDBBtn onClick={addTransportJob}>เพิ่มรายการขนส่ง</MDBBtn>
                        </MDBCardBody>

                    </MDBCard>
                </MDBCol>
            </MDBRow>

            <MDBCard className="shadow-4 rounded-5 mt-4">
                <MDBCardHeader>
                    <h5>ข้อมูลใบงานวิ่งรถ</h5>
                </MDBCardHeader>
                <MDBCardBody>

                    <div className="">
                        <MDBDatatable hover data={resultData} rowsText="แสดง" noFoundMessage="ไม่มีข้อมูล" ofText="จาก" allText="ทั้งหมด" />
                    </div>
                    <div className="d-grid gap-2 d-md-flex justify-content-md-end">
                        <MDBBtn rounded size='lg' color='secondary' onClick={saveData} disabled={isLoading}>บันทึก</MDBBtn>
                    </div>
                </MDBCardBody>

            </MDBCard>


            <MDBModal open={basicModal} onClose={() => setBasicModal(false)} tabIndex='-1'>
                <MDBModalDialog centered size="xl">
                    <MDBModalContent>
                        <MDBModalHeader>
                            <MDBModalTitle>แก้ไขข้อมูลงาน</MDBModalTitle>
                            <MDBBtn className='btn-close' color='none' onClick={toggleOpen}></MDBBtn>
                        </MDBModalHeader>
                        <MDBModalBody>
                            {selectedrow && <JobDetail addNewAddress={addNewAddress} setError={setError} customers={customers} ref={editjob} job={selectedrow.row} mode="edit" disabledCustomer={transportJobList.length > 0} />}
                        </MDBModalBody>

                        <MDBModalFooter>
                            <MDBBtn color='secondary' onClick={toggleOpen}>
                                ปิด
                            </MDBBtn>
                            <MDBBtn onClick={endEdit}>บันทึก</MDBBtn>
                        </MDBModalFooter>
                    </MDBModalContent>
                </MDBModalDialog>
            </MDBModal>
        </MDBContainer>
    </>
    );
};

export default Component;
